import {toAbsoluteUrl} from '@/shared/utils'
import {useCognitoAuth} from '../core/CognitoAuth'
import {Auth} from 'aws-amplify'

import {toast} from 'react-toastify'
import {getLogger} from '../../../../shared/utils/logUtils'
import {toastDefaultConfig} from '../../../../shared/config/toastConfig'
import {ofuscateEmail} from './VerificationCodeInput'
import {Link} from 'react-router-dom'
import {useState} from 'react'

export const ValidateRegistration = () => {
  const {currentUser} = useCognitoAuth()
  const [resending, setResending] = useState(false)
  const [resent, setResent] = useState(false)

  const handleResend = async () => {
    if (!currentUser?.email) return
    setResending(true)
    try {
      await Auth.resendSignUp(currentUser.email)
      setResent(true)
      toast('Activation link resent. Please check your email.', {
        ...toastDefaultConfig,
        type: 'success',
      })
    } catch (error) {
      const message = error instanceof Error ? error.message : 'Failed to resend activation link'
      toast(message, {...toastDefaultConfig, type: 'error'})
      getLogger().error(error)
    } finally {
      setResending(false)
    }
  }

  return (
    <>
      <div className='container'>
        <div className='modal-dialog-cognito'>
          <div className='modal-content background-customizable modal-content-mobile'>
            <div className='text-center banner-customizable'>
              <img alt='Logo' src={toAbsoluteUrl('/media/logos/ob_web.png')} className='h-95px' />
            </div>
            <div className='modal-body'>
              <br />
              <div className='mb-5'>
                <h4 className='mb-4'>Check your email</h4>
                <p>
                  We have sent an activation link to{' '}
                  <strong>
                    {currentUser?.email ? ofuscateEmail(currentUser.email) : 'your email'}
                  </strong>
                  .
                </p>
                <p>Click the link in the email to activate your account, then sign in below.</p>
              </div>

              <Link to='..' className='btn btn-primary submitButton-customizable'>
                Go to Sign In
              </Link>

              <div className='mt-4 text-center'>
                <span className='text-muted'>Didn&apos;t receive the email?&nbsp;</span>
                <button
                  type='button'
                  className='btn btn-link p-0'
                  onClick={handleResend}
                  disabled={resending || resent}
                >
                  {resending ? 'Sending...' : resent ? 'Link resent' : 'Resend activation link'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
